"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RoundBadge = RoundBadge;
const jsx_runtime_1 = require("react/jsx-runtime");
const server_1 = require("@kalkulacka-one/design-system/server");
const next_intl_1 = require("next-intl");
/** The current round of an election with more than one; nothing otherwise. */
function RoundBadge({ round }) {
    const t = (0, next_intl_1.useTranslations)("koa.components.roundBadge");
    if (round === undefined || round.total <= 1)
        return null;
    return (0, jsx_runtime_1.jsx)(server_1.Badge, { color: "primary", children: t("round", { round: round.current }) });
}
